module.exports = __webpack_public_path__ + "static/feature-2-994ab67d45e00335d2d8e36d1adb1039.svg";